import { Subscription } from '@/types/subscriptions';
import { SubscriptionStatus } from '@/constants/subscription_status';
import { durations, planTypes, SCHEDULE_STATES } from '@/constants/subscriptions';

export const getPlanSubscription = (
    subscriptions: Subscription[],
    planId: string,
    deviceUUID: string,
): Subscription | null => {
    const planSubscription = subscriptions.find((item) => {
        return item.sourceData?.metadata?.planId === planId && item.deviceUUID === deviceUUID;
    });
    return planSubscription === undefined ? null : planSubscription;
};

export const getDeviceSubscription = (subscriptions: Subscription[], deviceUUID: string): Subscription[] => {
    const deviceSubscription = subscriptions.find((item) => item.deviceUUID === deviceUUID);
    return deviceSubscription === undefined ? [] : [deviceSubscription];
};

export const getSubscriptionDuration = (duration: string) => {
    const durationItem = durations.find((item) => item.value === duration);
    return durationItem ? durationItem.text : '-';
};

export const getPlanType = (type: string) => {
    const typeItem = planTypes.find((item) => item.value === type);
    return typeItem ? typeItem.text : '-';
};

export const planUpdateAble = (subscription: Subscription) => {
    const { status, cancel_at_period_end, pause_collection } = subscription.sourceData;
    return status === SubscriptionStatus.Trialing ||
        cancel_at_period_end == true ||
        (pause_collection && Object.keys(pause_collection).length > 0)
        ? false
        : true;
};

export const getSchedulePlanId = (subscription: Subscription) => {
    const { scheduleDetails } = subscription.sourceData;
    if (scheduleDetails) {
        const { state } = scheduleDetails.phases[1].metadata;

        if (
            state === SCHEDULE_STATES.downgrade &&
            scheduleDetails?.current_phase?.start_date != scheduleDetails?.phases[1]?.start_date
        ) {
            return scheduleDetails.phases[1].metadata.planId;
        }
    }

    return '';
};
